<template>
  <div class="section">
    <div class="section-top">
      <div class="title">{{ title }}</div>
      <div class="tips" v-if="showTips">数据来自咪咕，延迟1小时左右更新</div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
// import Pie from './pie.vue';
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    showTips: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  activated() {},
  computed: {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.section {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 12px 24px 24px;
  margin-bottom: 16px;
  &-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0,0,0,0.04);
    padding: 9px 0px;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #000;
      line-height: 22px;
    }
    .tips {
      font-size: 12px;
      font-weight: 400;
      color: #A9A9AA;
    }
  }
}
</style>